import { render, staticRenderFns } from "./KindsOfSportsPage.vue?vue&type=template&id=6a4651e9&"
import script from "./KindsOfSportsPage.vue?vue&type=script&lang=js&"
export * from "./KindsOfSportsPage.vue?vue&type=script&lang=js&"
import style0 from "./KindsOfSportsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports